module.exports = __webpack_public_path__ + "img/icon-star.8d690bce.svg";